import styles from './DealTypeBadge.module.css';

interface Props {
  type: string | null;
}

export function DealTypeBadge({ type }: Props) {
  const normalized = (type || '').toLowerCase();
  if (normalized === 'add-on') {
    return <span className={styles.badge}>ADD-ON</span>;
  }
  if (normalized === 'new (ex-fund)') {
    return <span className={`${styles.badge} ${styles.exFund}`}>EX-FUND</span>;
  }
  return null;
}
